import React from 'react';
import { Spin } from 'antd';

const SpinnerFull = () => (
  <Spin
    spinning
    size="large"
    style={{ maxHeight: 'unset' }}
  >
    <div style={{ width: '100vh', height: '100vh' }} />
  </Spin>
);

export default SpinnerFull;
